import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'intro-page';

export type introPage = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
}
export class introPageApi extends BaseAPI {
    static getDataDetail(): Promise<AxiosResponse> {
        return this.api.get(`${path}`)
    }
    static create(body: any): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
}